module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-bar"
  }, [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.breadcrumbArray
    }
  })], 1), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Reward Tiers")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), (_vm.$root.permissions['reward_tiers create']) ? _c('div', {
    staticClass: "portlet box blue-hoki"
  }, [_c('div', {
    staticClass: "portlet-title bg-blue-chambray",
    on: {
      "click": function($event) {
        _vm.toggleCreateTierPanel()
      }
    }
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "tools"
  }, [_c('a', {
    class: {
      'expand': !_vm.createTierCollapse, 'collapse': _vm.createTierCollapse
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body",
    class: {
      'display-hide': _vm.createTierCollapse
    }
  }, [_c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createRewardsTier()
      }
    }
  }, [_c('div', {
    staticClass: "form-body row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.errorMessage.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newRewardsTier.name),
      expression: "newRewardsTier.name"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newRewardsTier.name.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_1"
    },
    domProps: {
      "value": (_vm.newRewardsTier.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newRewardsTier, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_1"
    }
  }, [_vm._v("Reward Tier Name")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newRewardsTier.description),
      expression: "newRewardsTier.description"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newRewardsTier.description.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_3"
    },
    domProps: {
      "value": (_vm.newRewardsTier.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newRewardsTier, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_3"
    }
  }, [_vm._v("Reward Tier Description")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newRewardsTier.points),
      expression: "newRewardsTier.points"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newRewardsTier.points !== null
    },
    attrs: {
      "type": "text",
      "id": "form_control_2"
    },
    domProps: {
      "value": (_vm.newRewardsTier.points)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newRewardsTier, "points", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_2"
    }
  }, [_vm._v("Reward Tier Points")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newRewardsTier.stars),
      expression: "newRewardsTier.stars"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newRewardsTier.stars !== null
    },
    attrs: {
      "type": "text",
      "id": "form_control_3"
    },
    domProps: {
      "value": (_vm.newRewardsTier.stars)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newRewardsTier, "stars", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_3"
    }
  }, [_vm._v("Reward Tier Stars")])])])]), _vm._v(" "), _vm._m(2, false, false)])])]) : _vm._e(), _vm._v(" "), _c('loading-screen', {
    attrs: {
      "show": _vm.displayRewardsData,
      "color": '#2C3E50',
      "display": 'inline'
    }
  }), _vm._v(" "), (_vm.rewardTiers.length && !_vm.displayRewardsData) ? _c('div', [_c('div', {
    staticClass: "portlet light portlet-fit bordered margin-top-20"
  }, [_vm._m(3, false, false), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [(_vm.rewardTiers.length) ? _c('div', {
    staticClass: "mt-element-list margin-top-15"
  }, [_c('div', {
    staticClass: "mt-list-container list-news ext-1 no-border"
  }, [_c('ul', _vm._l((_vm.rewardTiers), function(tier) {
    return _c('li', {
      key: tier.id,
      staticClass: "mt-list-item actions-at-left margin-top-15 clickable",
      attrs: {
        "id": 'tier-' + tier.id
      },
      on: {
        "click": function($event) {
          _vm.openTier(tier)
        }
      }
    }, [_c('div', {
      staticClass: "list-item-actions cursor-pointer",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [(_vm.$root.permissions['reward_tiers update']) ? _c('el-tooltip', {
      attrs: {
        "content": "Edit",
        "effect": "light",
        "placement": "right"
      }
    }, [_c('a', {
      staticClass: "btn btn-circle btn-icon-only btn-default",
      on: {
        "click": function($event) {
          _vm.showEditTierModal(tier, $event)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-pencil"
    })])]) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['reward_tiers read'] && !_vm.$root.permissions['reward_tiers update']) ? _c('el-tooltip', {
      attrs: {
        "content": "View",
        "effect": "light",
        "placement": "right"
      }
    }, [_c('a', {
      staticClass: "btn btn-circle btn-icon-only btn-default",
      on: {
        "click": function($event) {
          _vm.showEditTierModal(tier, $event)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-eye"
    })])]) : _vm._e()], 1), _vm._v(" "), _vm._m(4, true, false), _vm._v(" "), _c('div', {
      staticClass: "list-item-content height-mod"
    }, [_c('div', {
      staticClass: "col-sm-5"
    }, [_c('div', {
      staticClass: "bold uppercase font-red"
    }, [_c('span', [_vm._v(_vm._s(tier.name))])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Description:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(tier.description))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-5"
    }, [_c('div', [_c('strong', [_vm._v("Points:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(tier.points))])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Starts:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(tier.stars))])])])])])
  }))])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (!_vm.rewardTiers.length && !_vm.displayRewardsData) ? _c('div', [_c('no-results', {
    attrs: {
      "show": !_vm.rewardTiers.length,
      "type": 'reward tiers'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.displayEditTierModal) ? _c('edit-rewards-tier', {
    attrs: {
      "passedRewardTier": _vm.passedRewardTier
    },
    on: {
      "closeEditTierModal": _vm.closeEditTierModal,
      "updateRewardTier": _vm.updateRewardTier
    }
  }) : _vm._e(), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.displayDeleteModal,
      "effect": "fade"
    },
    on: {
      "closeOnEscape": _vm.closeDeleteModal
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeDeleteModal()
      }
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title center"
  }, [_vm._v("Delete Tier")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deleteErrorMessage.length),
      expression: "deleteErrorMessage.length"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.clearDeleteError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.deleteErrorMessage))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', [_vm._v("Are you sure you want to delete " + _vm._s(_vm.tierToBeDeleted.name) + "?")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn blue",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.deleteTier()
      }
    }
  }, [_vm._v("Delete")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "note note-info"
  }, [_c('p', [_vm._v("Add and manage an application's reward tiers and their items.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-2x fa-plus-circle"
  }), _vm._v("\n\t\t\t\t\tCreate a New Reward Tier\n\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-actions right margin-top-20"
  }, [_c('button', {
    staticClass: "btn blue",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Create")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title bg-blue-chambray"
  }, [_c('div', {
    staticClass: "menu-image-main"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/client_logo.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "caption-subject font-green bold uppercase"
  }, [_vm._v("Reward Tier")]), _vm._v(" "), _c('div', {
    staticClass: "caption-desc font-grey-cascade"
  }, [_vm._v("Click on a tier to view its items.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-icon-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72c0b354"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/Rewards.vue
// module id = 751
// module chunks = 0